export class I18nService {
    getText(text) {
        return text;
    }
}
